import React, { PropsWithChildren } from 'react';

const Portlet: React.FunctionComponent<PropsWithChildren<{
	title?: string,
	note?: string | React.ReactNode,
	isLarge?: boolean
}>> = ({ title, note, isLarge, children }) => {

	if (isLarge)
		return <div className="divide-y divide-gray-200 rounded-lg bg-white shadow">
			<div className="px-4 py-5 sm:px-6">
				<div className="flex flex-wrap items-center justify-between sm:flex-nowrap min-h-[38px]">
					<div className="flex items-center">
						<h3 className="text-lg font-semibold leading-6 text-gray-900">{title}</h3>
						{note && <div className="text-xs font-medium text-gray-400">{note}</div>}
					</div>
					<div className="flex-shrink-0"></div>
				</div>
			</div>
			<div className="px-4 py-5 sm:p-6">
				{children}
			</div>
		</div>;

	else return <div className="rounded-lg bg-white shadow p-4">
		<div className="flex justify-between items-center mb-3">
			<h2 className="text-base font-semibold text-gray-900">{title}</h2>
			{note && <div className="text-xs font-medium text-gray-400">{note}</div>}
		</div>
		<div className="wrapper">
			{children}
		</div>
	</div>;
};

export default Portlet;